import type { SVGProps } from "react";
import * as React from "react";

const SvgFacebookGrey = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 25"
    {...props}
  >
    <g clipPath="url(#facebook-grey_svg__a)">
      <path
        fill="#B5AEAB"
        d="M24 12.018c0-6.628-5.373-12-12-12s-12 5.372-12 12c0 5.989 4.388 10.954 10.125 11.854v-8.386H7.078v-3.468h3.047V9.374c0-3.008 1.792-4.669 4.533-4.669 1.312 0 2.686.234 2.686.234v2.954H15.83c-1.491 0-1.956.925-1.956 1.875v2.25h3.328l-.532 3.468h-2.796v8.386C19.612 22.972 24 18.007 24 12.018"
      />
    </g>
    <defs>
      <clipPath id="facebook-grey_svg__a">
        <path
          fill="#fff"
          d="M0 .018h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFacebookGrey;
